import type { AuthState } from '@b2x/authentication';

import { buildLoginObject, dispatchLoginActionEvent } from '@/utilities/helpers';
import { logger } from '@/utilities/logger';

import { getMarketFlow } from './flow';
import { runMarketFlow } from './flow-runner';

const log = logger.createLogger('BOOTSTRAP');

export async function initializeLoginActionsLibrary(country: string, authState: AuthState) {
  try {
    const marketFlow = getMarketFlow(country.toLowerCase());
    const loginData = buildLoginObject(authState, country);

    await runMarketFlow(marketFlow, loginData);
    dispatchLoginActionEvent('login-action:done', { country });
  } catch (error) {
    dispatchLoginActionEvent('login-action:failed', { country });
    log.error('Error initializing login actions library', error);
  }
}
